"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.walletReducer = exports.INITIAL_STATE = void 0;

var reducer_1 = require("../loading/reducer");

var actions_1 = require("./actions");

exports.INITIAL_STATE = {
  data: null,
  loading: [],
  error: null,
  hasAcceptedNetworkPartialSupport: false
};

function walletReducer() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : exports.INITIAL_STATE;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case actions_1.FETCH_WALLET_REQUEST:
    case actions_1.ENABLE_WALLET_REQUEST:
    case actions_1.CONNECT_WALLET_REQUEST:
      {
        return Object.assign(Object.assign({}, state), {
          loading: reducer_1.loadingReducer(state.loading, action)
        });
      }

    case actions_1.FETCH_WALLET_SUCCESS:
    case actions_1.CONNECT_WALLET_SUCCESS:
      {
        return Object.assign(Object.assign({}, state), {
          loading: reducer_1.loadingReducer(state.loading, action),
          error: null,
          data: action.payload.wallet
        });
      }

    case actions_1.FETCH_WALLET_FAILURE:
    case actions_1.CONNECT_WALLET_FAILURE:
      {
        return Object.assign(Object.assign({}, state), {
          loading: reducer_1.loadingReducer(state.loading, action)
        });
      }

    case actions_1.ENABLE_WALLET_SUCCESS:
      {
        return Object.assign(Object.assign({}, state), {
          loading: reducer_1.loadingReducer(state.loading, action),
          error: null,
          hasAcceptedNetworkPartialSupport: false
        });
      }

    case actions_1.ENABLE_WALLET_FAILURE:
      {
        return Object.assign(Object.assign({}, state), {
          loading: reducer_1.loadingReducer(state.loading, action),
          error: action.payload.error
        });
      }

    case actions_1.CHANGE_ACCOUNT:
      {
        return Object.assign(Object.assign({}, state), {
          error: null,
          data: action.payload.wallet
        });
      }

    case actions_1.CHANGE_NETWORK:
      {
        return Object.assign(Object.assign({}, state), {
          error: null,
          data: action.payload.wallet,
          hasAcceptedNetworkPartialSupport: false
        });
      }

    case actions_1.DISCONNECT_WALLET:
      {
        return Object.assign(Object.assign({}, state), {
          error: null,
          data: null
        });
      }

    case actions_1.ACCEPT_NETWORK_PARTIAL_SUPPORT:
      {
        return Object.assign(Object.assign({}, state), {
          hasAcceptedNetworkPartialSupport: true
        });
      }

    default:
      return state;
  }
}

exports.walletReducer = walletReducer;